import React, { useContext, useMemo, useState } from 'react'
import { ErrorAlert } from '../error/error-alert'

const AlertException = React.createContext()

export const useAlertException = () => useContext(AlertException)

export const AlertExceptionProvider = ({ children }) => {
  const [exception, updateException] = useState(null)

  const handleClose = () => updateException(null)

  return (
    <AlertException.Provider value={{ updateException }}>
      <div className="d-flex flex-column h-100">
        <div>
          <AlertErrorException exception={exception} onClose={handleClose} />
        </div>
        <div className="flex-fill h-100">
          {children}
        </div>
      </div>
    </AlertException.Provider>
  )
}

// The layout's alert for a failed save (FormSimple) or load (the grids'
// onReady): the server's message and the failed request's id
// (error-reference.js).
const AlertErrorException = ({ exception, onClose }) => {
  const message = useMemo(
    () => {
      if (!exception) {
        return null
      }

      if (exception.data && exception.data.message) {
        return exception.data.message
      }

      return 'An error occurred.'
    },
    [exception]
  )

  return message ? <ErrorAlert message={message} error={exception} onClose={onClose} /> : null
}
